<p>
  project-control-detail works!
</p>
